import { type FetchPromoContractParams, PromoContractsApi } from '@/api/domains/promo-contracts.api';
import { PromoContractsQueryKeys } from '@/api/domains/promo-contracts.query-keys';
import { useQuery } from '@tanstack/react-query';

export const usePromoContract = (params: Partial<FetchPromoContractParams>) => {
  const { contractId, ...restOfParams } = params;
  return useQuery({
    queryKey: PromoContractsQueryKeys.getContractKey(params),
    queryFn: () => {
      if (params && contractId) {
        return PromoContractsApi.fetchPromoContract({ contractId, ...restOfParams });
      }
    },
    refetchOnWindowFocus: false,
    enabled: !!params && !!params.contractId,
  });
};
